<template>
  <div class="cart-calculator">
    <ul class="list-group mb-3">
      <li class="list-group-item d-flex justify-content-between">
        <span>Total (PEN)</span>
        <strong>{{ totalValue | currency }}</strong>
      </li>
      <li class="list-group-item d-flex justify-content-between">
        <small
          ><strong
            ><input type="checkbox" id="checkbox" v-model="checked" /> He leido y estoy de acuerdo
            con las
            <router-link to="/guia/7" target="_blank">Terminos y Condiciones</router-link> de
            Armaq.</strong
          ></small
        >
      </li>
      <template v-if="cartProducts.length > 0">
        <template v-if="general_allowed_sale == true">
          <template v-if="general_allowed_tpv == true">
            <template v-if="checked === true">
              <template v-if="loggedUserData">
                <router-link
                  :to="'/datos-compra'"
                  class="btn btn-primary mt-2 text-white"
                  :disabled="checked === false"
                  >Siguiente</router-link
                >
              </template>
              <template v-else>
                <a
                  data-toggle="modal"
                  data-target="#myModal2"
                  class="btn btn-primary mt-2 text-white"
                  :disabled="checked === false"
                  href
                  >Siguiente</a
                >
              </template>
            </template>
          </template>
        </template>
        <template v-else>
          <small style="color:#dc3545;"
            >Uno o varios de los productos seleccioandos no se encuentran habilitados para el pedido
            o venta online. Agrege solamente productos habilitados.</small
          >
        </template>
      </template>
    </ul>
    <div :class="[successMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
      <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button
      ><strong>{{ successMessage }}<router-link to="/pedidos">aquí</router-link>.</strong>
    </div>
    <div :class="[errorMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
      <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button
      ><strong><span v-html="errorMessage"></span></strong>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import axios from 'axios';
import { mapState, mapActions, mapMutations } from 'vuex';
import { UNAUTHORIZED } from '@/types/httpd.constants';
import { config_settings } from '@/config.js';
import { postLogin, postNewAccountToErp, getProfileData } from '@/service/account.service';
import {
  generateRefreshTokenBodyRequest,
  getAccessToken,
  setTokens,
} from '@/helpers/localStorage.helpers';

export default {
  name: 'cartCalculator',
  props: ['totalValue', 'general_allowed_sale', 'general_allowed_tpv'],
  data() {
    return {
      checked: true,
      successMessage: '',
      errorMessage: '',
      loggedUserData: null,
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    analizeCart() {
      this.$parent.analizeCart();
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    getUserData() {
      getProfileData(getAccessToken())
        .then((response) => {
          this.loggedUserData = response.data;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.getUserData();
              })
              .catch((_) => {});
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    ocultar() {
      this.successMessage = '';
      this.errorMessage = '';
    },
    ...mapMutations(['SET_CART_PRODUCTS']),

    removeAllProductCart() {
      var products = [];
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.analizeCart();
    },
  },

  created() {
    this.analizeCart();
    this.getUserData();
  },
};
</script>
<style>
.warning-p {
  color: #ce3e3e;
}
.fa-mrbig {
  font-size: 80px;
  color: crimson;
}
</style>
